import { render } from "./TaskVerbalFluency.vue?vue&type=template&id=65109cda"
import script from "./TaskVerbalFluency.vue?vue&type=script&lang=js"
export * from "./TaskVerbalFluency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__